/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Spain_Faq_A7Inputs */

const es_marketplace_seo_spain_faq_a7 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depende del barco: sin titulación hasta 5 m y 15 CV; Licencia de Navegación (LN) y PNB para embarcaciones pequeñas cerca de costa; PER para lanchas hasta 15 m y veleros hasta 20 m; Patrón y Capitán de Yate para embarcaciones mayores o navegación más exigente. Si no tienes la titulación adecuada, alquila con patrón.`)
};

const gl_marketplace_seo_spain_faq_a7 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depende do barco: sen titulación ata 5 m e 15 CV; Licenza de Navegación (LN) e PNB para embarcacións pequenas preto da costa; PER para lanchas ata 15 m e veleiros ata 20 m; Patrón e Capitán de Iate para embarcacións maiores ou navegación máis exixente. Se non tes a titulación axeitada, aluga con patrón.`)
};

const en_marketplace_seo_spain_faq_a7 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It depends on the boat: no licence up to 5 m and 15 HP; Navigation Licence (LN) and PNB for small craft near shore; PER for motorboats up to 15 m and sailboats up to 20 m; Yachtmaster and Captain for larger boats or longer passages. If you lack the right licence, rent with a skipper.`)
};

/**
* | output |
* | --- |
* | "It depends on the boat: no licence up to 5 m and 15 HP; Navigation Licence (LN) and PNB for small craft near shore; PER for motorboats up to 15 m and sailboa..." |
*
* @param {Marketplace_Seo_Spain_Faq_A7Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_spain_faq_a7 = /** @type {((inputs?: Marketplace_Seo_Spain_Faq_A7Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Spain_Faq_A7Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_spain_faq_a7(inputs)
	if (locale === "en") return en_marketplace_seo_spain_faq_a7(inputs)
	return es_marketplace_seo_spain_faq_a7(inputs)
});